import { useState } from "react";
import ScrollReveal from "./ScrollReveal";

type YtFacadeProps = { id: string; title: string };

const YouTubeFacade = ({ id, title }: YtFacadeProps) => {
  const [active, setActive] = useState(false);
  const thumb = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

  if (active) {
    return (
      <iframe
        className="w-full h-full"
        src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setActive(true)}
      aria-label={`Assistir: ${title}`}
      className="group relative w-full h-full block cursor-pointer"
    >
      <img
        src={thumb}
        alt={title}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex items-center justify-center w-16 h-16 rounded-full bg-red-600 shadow-lg group-hover:scale-110 transition-transform">
          <svg viewBox="0 0 24 24" fill="white" className="w-7 h-7 ml-1" aria-hidden="true">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
      </span>
    </button>
  );
};

const VideoSection = () => {
  return (
    <section className="py-20 bg-section-soft relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 section-glow-divider" />

      <div className="container mx-auto px-4">
        <ScrollReveal className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-primary font-semibold uppercase tracking-[0.2em] text-sm mb-3">
              Vídeos
            </p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground mb-3">
              Conheça a Equilybra
            </h2>
            <div className="w-16 h-1 mx-auto mb-4 rounded-full bg-gradient-to-r from-primary to-accent" />
            <p className="text-muted-foreground max-w-xl mx-auto">
              Assista e descubra como podemos ajudar você a encontrar o equilíbrio
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <ScrollReveal delay={0.1} direction="left">
            <div className="relative rounded-2xl overflow-hidden shadow-soft bg-card border border-border glow-primary">
              <div className="aspect-video">
                <YouTubeFacade id="WTUsewWyGTc" title="Equilybra Psicologia - Vídeo 1" />
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2} direction="right">
            <div className="relative rounded-2xl overflow-hidden shadow-soft bg-card border border-border glow-primary">
              <div className="aspect-video">
                <YouTubeFacade id="K6JwMYObqvQ" title="Equilybra Psicologia - Vídeo 2" />
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
